import apiClient from "Configuration/apiClient";

const AUTH_ENDPOINT = "/api/v1/auth";

export const login = (credentials) => {
  return apiClient.post(AUTH_ENDPOINT, credentials);
};

export default {
  login,
};